import { render } from "./FormAdd.vue?vue&type=template&id=728fc6f1&scoped=true"
import script from "./FormAdd.vue?vue&type=script&lang=js"
export * from "./FormAdd.vue?vue&type=script&lang=js"

import "./FormAdd.vue?vue&type=style&index=0&id=728fc6f1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728fc6f1"]])

export default __exports__